'use client';

import { c as _c } from "react/compiler-runtime";
import { getBudgetsByCodePath, getCodePathFromParams } from '@/modules/finances/lib/utils';
import { ATLAS_BUDGETS, BUDGETS } from '../../mocks';
import { BreakdownChart } from './breakdown-chart';
import { BreakdownLegend } from './breakdown-legend';
import { useBreakdownChart } from './use-breakdown-chart';
import type { BreakdownBudgetAnalytic, GRANULARITY_OPTIONS, METRIC_OPTIONS } from '../../types';
interface BreakdownChartContentProps {
  params?: string[];
  budgetsAnalytics: BreakdownBudgetAnalytic;
  year: string;
  granularity: GRANULARITY_OPTIONS;
  metric: METRIC_OPTIONS;
}
function BreakdownChartContent(t0) {
  const $ = _c(28);
  const {
    params,
    budgetsAnalytics,
    year,
    granularity,
    metric
  } = t0;
  let codePath;
  let t1;
  if ($[0] !== params) {
    codePath = getCodePathFromParams(params);
    t1 = getBudgetsByCodePath(codePath, BUDGETS);
    $[0] = params;
    $[1] = codePath;
    $[2] = t1;
  } else {
    codePath = $[1];
    t1 = $[2];
  }
  const budgets = t1;
  let t2;
  if ($[3] !== budgets || $[4] !== budgetsAnalytics || $[5] !== codePath || $[6] !== granularity || $[7] !== metric || $[8] !== year) {
    t2 = {
      budgetsAnalytics,
      budgets,
      allBudgets: ATLAS_BUDGETS,
      year,
      codePath,
      granularity,
      metric
    };
    $[3] = budgets;
    $[4] = budgetsAnalytics;
    $[5] = codePath;
    $[6] = granularity;
    $[7] = metric;
    $[8] = year;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  const {
    series,
    showScrollAndToggle,
    handleToggleSeries,
    handleChangeSwitch,
    isChecked,
    refBreakDownChart,
    onLegendItemHover,
    onLegendItemLeave,
    showLegendValue,
    selectedGranularity,
    selectedMetric
  } = useBreakdownChart(t2);
  let t3;
  if ($[10] !== refBreakDownChart || $[11] !== selectedGranularity || $[12] !== selectedMetric || $[13] !== series || $[14] !== year) {
    t3 = <div className="flex min-w-0 flex-1"><BreakdownChart refBreakDownChart={refBreakDownChart} year={year} selectedGranularity={selectedGranularity} series={series} selectedMetric={selectedMetric} key={selectedGranularity} /></div>;
    $[10] = refBreakDownChart;
    $[11] = selectedGranularity;
    $[12] = selectedMetric;
    $[13] = series;
    $[14] = year;
    $[15] = t3;
  } else {
    t3 = $[15];
  }
  let t4;
  if ($[16] !== handleChangeSwitch || $[17] !== handleToggleSeries || $[18] !== isChecked || $[19] !== onLegendItemHover || $[20] !== onLegendItemLeave || $[21] !== series || $[22] !== showLegendValue || $[23] !== showScrollAndToggle) {
    t4 = <div className="flex w-full md:w-65.75 lg:w-90.5 xl:w-88.75 2xl:w-98"><BreakdownLegend series={series} handleToggleSeries={handleToggleSeries} onLegendItemHover={onLegendItemHover} onLegendItemLeave={onLegendItemLeave} showLegendValue={showLegendValue} showScrollAndToggle={showScrollAndToggle} isChecked={isChecked} handleChangeSwitch={handleChangeSwitch} /></div>;
    $[16] = handleChangeSwitch;
    $[17] = handleToggleSeries;
    $[18] = isChecked;
    $[19] = onLegendItemHover;
    $[20] = onLegendItemLeave;
    $[21] = series;
    $[22] = showLegendValue;
    $[23] = showScrollAndToggle;
    $[24] = t4;
  } else {
    t4 = $[24];
  }
  let t5;
  if ($[25] !== t3 || $[26] !== t4) {
    t5 = <div className="flex w-full flex-col gap-4 sm:gap-6 md:flex-row 2xl:gap-8">{t3}{t4}</div>;
    $[25] = t3;
    $[26] = t4;
    $[27] = t5;
  } else {
    t5 = $[27];
  }
  return t5;
}
export { BreakdownChartContent };